//https://icomoon.io/#preview-free
import Icon from './icon'
export default Icon

export defaultIcon  from './errIcon.svg'

export gameSonyPlus from './game/sonyPlus.svg'
export gameSonyCross from './game/sonyCross.svg'
export gameSonySquare from './game/sonySquare.svg'
export gameSonyCircle from './game/sonyCircle.svg'
export gameSonyTriangle from './game/sonyTriangle.svg'

export bars from './loading/loading-bars.svg';
export bubbles from './loading/loading-bubbles.svg';
export cylon from './loading/loading-cylon.svg';
export spin from './loading/loading-spin.svg';
export spinningBubbles from './loading/loading-spinning-bubbles.svg';

export expandMore from './expand/expand_more.svg';
export expandLess from './expand/expand_less.svg';
export expandEmpty from './expand/expand_empty.svg';
export close from './close.svg';
export closeV2 from './closeV2.svg';
export error from './errIcon.svg';

export colorPicker from './color_picker.svg';

// navigation
export previousPage from './navigation/chevron_left.svg'
export nextPage from './navigation/chevron_right.svg'
export morePages from './navigation/more_horiz.svg'
export firstPage from './navigation/first_page.svg'
export lastPage from './navigation/last_page.svg'

export deleted from './bin.svg'

export eye from './eyes/eye.svg'
export eyeBlocked from './eyes/eye_blocked.svg'
export eyeMinus from './eyes/eye_minus.svg'
export eyePlus from './eyes/eye_plus.svg'

export menu from './menu.svg'

export save from './save.svg'
export info from './info.svg'
export home from './home.svg'
export edit from './edit.svg'
export eyedropper from './eyedropper.svg'
export image from './image.svg'
export film from './film.svg'
export videoCamera from './video_camera.svg'
export profile from './profile.svg'
export calendar from './calendar.svg'
export mobile from './mobile.svg'
export tablet from './tablet.svg'
export list from './list.svg'
export link from './link.svg'
export plus from './plus.svg'
export minus from './minus.svg'
export cancelCircle from './cancel_circle.svg'
export blocked from './blocked.svg'
export cross from './cross.svg'
export checkmark from './checkmark.svg'
export previous from './previous.svg'
export next from './next.svg'
export circleRight from './circle_right.svg'
export circleDown from './circle_down.svg'
export sortasc from './sort_asc.svg'
export sortdesc from './sort_desc.svg'

export user from './user/user.svg'
export users from './user/users.svg'
export userTie from './user/user_tie.svg'
export userPlus from './user/user_plus.svg'
export userMinus from './user/user_minus.svg'
export userCheck from './user/user_check.svg'

export fileText from './file/file_text.svg'
export fileEmpty from './file/file_empty.svg'
export filesEmpty from './file/files_empty.svg'

export folder from './folder/folder.svg'
export folderOpen from './folder/folder_open.svg'
export folderPlus from './folder/folder_plus.svg'
export folderMinus from './folder/folder_minus.svg'
export folderDownload from './folder/folder_download.svg'
export folderUpload from './folder/folder_upload.svg'

export arrowDown from './arrow/arrow-down.svg'
export arrowDownLeft from './arrow/arrow-down-left.svg'
export arrowDownRight from './arrow/arrow-down-right.svg'
export arrowLeft from './arrow/arrow-left.svg'
export arrowRight from './arrow/arrow-right.svg'
export arrowUp from './arrow/arrow-up.svg'
export arrowUpLeft from './arrow/arrow-up-left.svg'
export arrowUpRight from './arrow/arrow-up-right.svg'

export clock from './new/clock.svg'
export bin from './new/bin.svg'

export checkboxChecked from './checkbox-checked.svg'
export checkboxUnchecked from './checkbox-unchecked.svg'

export share from './share.svg'

export paragraphJustify from './paragraph-justify.svg'
export stack from './stack.svg'

//environement
export pages from './environement/pages.svg'
export seo from './environement/seo.svg'
export socialExpire from './environement/expired.svg'
export socialCancelExpire from './environement/notExpired.svg'


//TEMP
export enter from './enter.svg'
